import { render } from "./CalculaterStationaryPage.vue?vue&type=template&id=250d1470&scoped=true"
import script from "./CalculaterStationaryPage.vue?vue&type=script&lang=js"
export * from "./CalculaterStationaryPage.vue?vue&type=script&lang=js"

import "./CalculaterStationaryPage.vue?vue&type=style&index=0&id=250d1470&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250d1470"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QCardSection,QSeparator});
